import React from 'react';
import { Reveal } from './showcase/Reveal';
import { LeadFlowDiagram } from './showcase/LeadFlowDiagram';
interface SystemMapSectionProps {
  surface?: 'ink-800' | 'ink-900';
}
export function SystemMapSection({
  surface = 'ink-800'
}: SystemMapSectionProps) {
  return <section id="system-map" aria-label="How the system connects" className={`border-b border-white/5 ${surface === 'ink-800' ? 'bg-ink-800' : 'bg-ink-900'}`} data-id="element-503" data-mp="1qk30pu6uwldg">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 sm:py-20" data-id="element-504" data-mp="1hrrbucre55zl">
        <Reveal data-id="element-505" data-mp="1hqg8ge1uy090">
          <LeadFlowDiagram data-id="element-506" data-mp="1hpwo6qoqizrt" />
        </Reveal>
      </div>
    </section>;
}